import React from "react";
import { Section, FadeUp, SectionHeading } from "./primitives";
import { deliveryFeatures } from "@/data/content";

export const Delivery = () => (
  <Section className="bg-white">
    <div className="max-w-[1100px] mx-auto">
      <FadeUp className="text-center max-w-[720px] mx-auto">
        <SectionHeading>How It's Delivered</SectionHeading>
      </FadeUp>
      <div className="mt-12 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
        {deliveryFeatures.map((f, i) => (
          <FadeUp key={f.title} delay={(i % 3) * 0.05}>
            <div
              data-testid={`delivery-card-${i}`}
              className="h-full bg-zinc-50 border border-zinc-200 rounded-xl p-8 shadow-sm hover:shadow-md transition-shadow duration-300"
            >
              <h3 className="text-xl font-bold text-zinc-900">{f.title}</h3>
              <p className="mt-2 text-base text-zinc-600 leading-relaxed">{f.text}</p>
            </div>
          </FadeUp>
        ))}
      </div>
    </div>
  </Section>
);
